var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadgesEarned(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 54,
    viewBox: "0 0 48 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1158_6892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0656 48.0077H7.10713C6.87537 48.0077 6.6875 48.1936 6.6875 48.4231V52.5827C6.6875 52.8121 6.87537 52.9981 7.10713 52.9981H19.0656C19.2973 52.9981 19.4852 52.8121 19.4852 52.5827V48.4231C19.4852 48.1936 19.2973 48.0077 19.0656 48.0077Z",
    stroke: "white",
    strokeWidth: 1.59269,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17544 46.9797V45.5624C8.17544 45.1113 8.02354 44.6752 7.74442 44.3181L1.64368 36.5402C1.22595 36.0083 1 35.3523 1 34.6794V25.2436C1 24.4654 1.37026 23.7343 1.99875 23.2681L2.2323 23.0933C3.02409 22.505 4.12157 22.5351 4.87918 23.1666C5.6159 23.7813 6.04123 24.6872 6.04123 25.6402V32.2622L9.55774 35.7432C9.70964 35.8936 9.96408 35.7545 9.91661 35.5459L9.4704 33.608C9.3128 32.9238 9.68116 32.2264 10.34 31.9652C11.0217 31.6945 11.7983 31.843 12.328 32.3467L16.8528 36.6398C17.3712 37.1323 17.675 37.8071 17.694 38.5194L17.9332 46.9797",
    stroke: "white",
    strokeWidth: 1.59269,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1922 53H41.1507C41.3824 53 41.5703 52.8141 41.5703 52.5846V48.425C41.5703 48.1956 41.3824 48.0096 41.1507 48.0096H29.1922C28.9605 48.0096 28.7726 48.1956 28.7726 48.425V52.5846C28.7726 52.8141 28.9605 53 29.1922 53Z",
    stroke: "white",
    strokeWidth: 1.59269,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0878 46.9795V45.5623C40.0878 45.1112 40.2397 44.6751 40.5189 44.318L46.6196 36.5382C47.0373 36.0062 47.2633 35.3503 47.2633 34.6773V25.2416C47.2633 24.4634 46.893 23.7323 46.2645 23.2661L46.031 23.0913C45.2392 22.503 44.1417 22.5331 43.3841 23.1646C42.6474 23.7792 42.2221 24.6852 42.2221 25.6382V32.2601L38.7055 35.7412C38.5536 35.8916 38.2992 35.7525 38.3467 35.5439L38.7929 33.606C38.9505 32.9218 38.5821 32.2244 37.9232 31.9632C37.2416 31.6925 36.465 31.841 35.9352 32.3447L31.4105 36.6378C30.8921 37.1303 30.5883 37.8051 30.5693 38.5174L30.3301 46.9777",
    stroke: "white",
    strokeWidth: 1.59269,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4838 7.71796L25.4586 9.67316C25.6214 9.99935 25.9352 10.2265 26.3 10.2789L28.481 10.5935C29.397 10.7255 29.7638 11.84 29.1008 12.4807L27.5219 14.0029C27.2591 14.2573 27.1375 14.6223 27.2003 14.9815L27.5729 17.1309C27.7298 18.0337 26.7707 18.723 25.9509 18.2978L24.0013 17.2823C23.6757 17.1134 23.2873 17.1134 22.9617 17.2823L21.0121 18.2978C20.1923 18.7249 19.2332 18.0357 19.3901 17.1309L19.7627 14.9815C19.8255 14.6223 19.7039 14.2573 19.4411 14.0029L17.8622 12.4807C17.1992 11.84 17.5641 10.7255 18.482 10.5935L20.663 10.2789C21.0278 10.2265 21.3417 9.99935 21.5044 9.67316L22.4792 7.71796C22.8892 6.89667 24.0738 6.89667 24.4838 7.71796Z",
    stroke: "white",
    strokeWidth: 1.6452,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4816 24.5323C30.046 24.5323 35.3675 19.2644 35.3675 12.7661C35.3675 6.26787 30.046 1 23.4816 1C16.9172 1 11.5957 6.26787 11.5957 12.7661C11.5957 19.2644 16.9172 24.5323 23.4816 24.5323Z",
    stroke: "white",
    strokeWidth: 1.6452,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9736 23.0372L14.261 25.9205C14.0295 26.1671 13.6275 26.0797 13.5117 25.7593L12.8155 23.8507C12.7586 23.6954 12.6272 23.5828 12.4683 23.5537L10.3775 23.1828C10.0244 23.1207 9.87732 22.678 10.1186 22.4042L12.8606 19.2996",
    stroke: "white",
    strokeWidth: 1.6452,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.25 23.0372L32.9626 25.9205C33.194 26.1671 33.5961 26.0797 33.7118 25.7593L34.4081 23.8507C34.465 23.6954 34.5964 23.5828 34.7553 23.5537L36.8461 23.1828C37.1991 23.1207 37.3462 22.678 37.105 22.4042L34.363 19.2996",
    stroke: "white",
    strokeWidth: 1.6452,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1158_6892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 54,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgesEarned);
export default __webpack_public_path__ + "static/media/badges_earned.0657aac25617be9dabbec0c13674b473.svg";
export { ForwardRef as ReactComponent };